import React from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

type Props = {
    title?: string | React.ReactNode;
    callback?: any;
    facilityUpdateTime: number | string | React.ReactNode;
};

const TitleWithUpdateButton = (props: Props) => {
    const { title, callback, facilityUpdateTime } = props;

    const updateHandlar = () => {
        const currentTime = new Date().getTime();
        callback && callback(currentTime);
    };

    return (
        <TitleWithStyled>
            {title}
            <UpdateTimeWithStyled>
                最終更新日時：{facilityUpdateTime}
            </UpdateTimeWithStyled>
            <UpdateButtonWithStyled>
                <Button variant='outline-success' size='sm' onClick={updateHandlar}>
                    更新
                </Button>
            </UpdateButtonWithStyled>
        </TitleWithStyled>
    );
};
const TitleWithStyled = styled.div`
    margin: 0;
    padding: 0;
`
const UpdateTimeWithStyled = styled.span`
    display: inline-block;
    font-weight: normal;
    font-size: 12px;
    margin-left: 20px;
`
const UpdateButtonWithStyled = styled.span`
    display: inline-block;
    & > .btn {
        position: absolute;
        bottom: 10px;
        font-size: 11px;
        margin-left: 10px;
        padding: 2px .5rem;
    }
`

export default TitleWithUpdateButton;